// extracted by mini-css-extract-plugin
export var aiStarIcon = "_b2-4";
export var closeButton = "_b2-6";
export var dismissButton = "_b2-3";
export var editImageWithAiContainer = "_b2-8";
export var imageUploadWrapper = "_b2-7";
export var misspelledWord = "_b2-5";
export var spellCheckContainer = "_b2-2";
export var spin = "_b2-1";
export var spinning = "_b2-0";